<template>
  <div class="table-div">
    <avue-crud ref="crud" :data="data" :option="TabOption" :page.sync="page" @on-load="onLoad"
      @search-change="searchChange" @size-change="sizeChange" @current-change="currentChange" @cell-click="rowEdit"
      :table-loading="loading" @search-reset="searchReset" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @selection-change="selectionChange">
      <!-- <template slot="clzt" slot-scope="scope">
          <template v-if="scope.row.clzt == 1"> 未通过 </template>
          <template v-else> 已通过 </template>
        </template> -->

      <template slot="menuLeft">
        <!-- <el-button type="primary" size="small" @click="downloadViewFunc"
            >下载模板</el-button
          >
  
          <el-button type="primary" size="small" @click="uploadFile"
            >导入</el-button
          > -->

        <!-- <el-button type="primary" size="small" @click="downloadDataFun"
            >导出</el-button
          > -->
      </template>
    </avue-crud>

    <!-- 导入模板选择试图 -->
    <el-dialog title="导入模板" :visible.sync="uploadView.show" width="30%" top="15vh" :append-to-body="true"
      @close="closeUploadDialog">
      <el-row>
        <el-form :inline="true" ref="downloadView" :model="uploadView.form" label-suffix=":">
          <el-col :span="24" ref="uploadViewData">
            <input type="file" class="file" @change="uploading($event)" />
            <el-button type="success" class="file_btn"><i class="el-icon-upload"></i><span
                v-text="uploadViewData.label">上传文件</span></el-button>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer">
        <el-button @click="uploadView.show = false">取 消</el-button>
        <el-button type="primary" @click="toUploadFile">确定上传</el-button>
      </span>
    </el-dialog>

    <!-- 导出数据 -->
    <el-dialog title="导出数据" :visible.sync="downloadData.show" width="30%" top="15vh" :append-to-body="true">
      <el-row>
        <el-form :inline="true" ref="downloadView" :model="downloadData.form" label-suffix=":">
          <el-col :span="24">
            <el-form-item label="文件名称" prop="fileName" :rules="[{ required: true, message: '请输入文件名' }]"
              :required="true">
              <el-input v-model="downloadData.form.fileName">
                <template slot="append">.zip</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer">
        <el-button @click="downloadData.show = false">取 消</el-button>
        <el-button type="primary" @click="todownloadData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { avueOptionsHandle } from "@/businessManagement/utils/jwTools";
import crudPageMinix from "@/businessManagement/utils/crudPageMinix";
export default {
  mixins: [crudPageMinix],
  data() {
    return {
      activeName: "first",
      data: [],
      loading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1,
      },
      search: {},
      TabOption: avueOptionsHandle({
        title: "pipeline统计",
        menuType: "text",
        page: true,
        align: "center",
        dateDefault: false,
        menuAlign: "center",
        selection: false,
        menu: true,
        refreshBtn: false,
        delBtn: false, //删除
        editBtn: false, //修改
        viewBtn: true,
        addBtn: false, //添加
        border: true,
        menuWidth: 100, //操作列宽度
        column: [

          {
            label: "姓名",
            prop: "xm",
            search: true
          },

          {
            prop: 'yf',
            label: '月份',
            type: "month",
            search: true,
            format: 'yyyy-MM',
            valueFormat: 'yyyy-MM',
          },

          {
            label: "类型",
            prop: "lx",
            type: "select",
            search: true,
            dicData: [
              {
                value: "平台pipeline新增",
                label: "平台pipeline新增",
              },
              {
                value: "新增客户信息",
                label: "新增客户信息",
              },
              {
                value: "pipeline新增",
                label: "pipeline新增",
              },
              {
                value: "pipeline提升",
                label: "pipeline提升",
              },
              {
                value: "pipeline下降",
                label: "pipeline下降",
              },
            ],
          },

          {
            label: "备注",
            prop: "bz",
          },

        ],
      }),


      uploadView: {
        show: false,
        form: {
          excelTemplateType: "",
          fileName: "科学活动申报数据",
        },
      },

      uploadViewData: {
        label: "上传文件",
      },

      downloadView: {
        show: false,
        form: {
          excelTemplateType: "",
          fileName: "科学活动申报数据",
        },
      },
      downloadErrorView: {
        show: false,
        form: {
          excelTemplateType: "",
          fileName: "错误数据",
        },
      },

      downloadData: {
        show: false,
        form: {
          excelTemplateType: "",
          fileName: "科学活动申报数据",
        },
      },
      tbSrc: "",
      file: "",
      src: "",
      FDFS_IMG: "",
      fileList: []
    };
  },
  mounted() {
    this.FDFS_IMG = window.config.FDFS_WEB_SERVER_URL;
  },
  methods: {
    // 分页查询
    load(done) {
      this.$http
        .post(
          "/yypipeline/getPipelineManage",
          {
            entity: {
              ...this.search,
            },
            orderItemList: [
              {
                asc: false,
                column: "id",
              },
            ],
          },
          {
            params: {
              pageNum: this.page.currentPage,
              pageSize: this.page.pageSize,
            },
          }
        )
        .then((res) => {
          this.data = res.data.records || [];
          this.page.total = res.data.total || res.data.records.length || 0;
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message);
        })
        .finally(() => {
          typeof done === "function" && done();
        });
    },
    onLoad(page) {
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.load();
    },
    searchChange(params, done) {
      this.search = params;
      this.page.currentPage = 1;
      this.load(done);
    },
    searchReset() {
      this.search = {};
      this.page.currentPage = 1;
      this.load();
    },
    refreshChange() {
      this.load();
    },

    showSystemDate: function () {
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };
      if (date.month < 10) {
        date.month = "0" + date.month;
      }
      if (date.date < 10) {
        date.date = "0" + date.date;
      }
      let systemDate = date.year + "-" + date.month + "-" + date.date;
      return systemDate;
    },
    downloadDataFun: function () {
      if (this.fileList.length > 10) {
        this.$message.warning("数据不能超过10条");
      } else if (this.fileList.length == 0) {
        this.$message.warning("请选择导出数据");
      } else {
        this.downloadData.show = true;
      }
      if (this.$refs.downloadData) {
        this.$refs.downloadData.resetFields();
      }
      let ststemDate = this.showSystemDate();
      this.downloadData.form = {
        excelTemplateType: "",
        fileName: "科学活动申报数据" + ststemDate,
      };
    },
    todownloadData: function () {
      this.$message.success("文件正在导出...");
      let params = {};

      params.fileName = this.downloadData.form.fileName + ".zip";
      params.doDownload = true;
      // params.list = this.fileList;

      this.$refs.downloadView.validate((valid) => {

        if (valid) {

          this.$downloadFile
            .get(
              "/kxhdsb/dataExport", //导出
              {
                list: this.fileList
              },
              { params }
            )
            .then((response) => {
              // 返回的内容
              this.$message.success(response.msg);
              this.downloadData.show = false;
              this.load();
            })
            .catch((error) => {
              this.$message.error(error);
            });


        }
      });
    },
    uploading(event) {
      this.file = event.target.files[0]; // 获取文件

      var windowURL = window.URL || window.webkitURL;

      this.file = event.target.files[0];

      // 创建图片文件的url

      this.src = windowURL.createObjectURL(event.target.files[0]);

      this.uploadViewData.label = this.file.name;
    },
    closeUploadDialog: function () {
      this.uploadViewData.label = "上传文件";
    },
    selectionChange(list) {
      this.fileList = list.map(item => {
        return item.id
      });
    }
  },
};
  </script>
  
  <style lang="scss" scoped>
.file {
  z-index: 999;
  opacity: 0;
  position: absolute;
  left: 2px;
  width: 140px;
  cursor: pointer;
  height: 44px;
}
.file_btn {
  position: absolute;
  left: 2px;
  width: auto;
  z-index: 0;
}
.table-div {
  padding: 20px 20px 100px;
  background-color: #fff;
  max-width: 1680px;
  width: calc(100% - 100px);
  margin: 10px auto;
  :deep(.avue-form__menu--center) {
    text-align: left;
  }
  :deep(.avue-crud__title) {
    height: 30px;
  }
  :deep(.el-tabs--border-card) {
    box-shadow: none;
  }

  .text-center {
    text-align: center;
  }

  .yy_notice {
    background-image: url("/base/images/scwlIndex/banner.png");
    width: 600px;
    margin: auto;
    border: 1px solid #ececec;
    text-align: center;
    height: 150px;
    line-height: 150px;
    color: white;
    margin-bottom: 30px;
  }
}
</style>